import { Component, HostListener, OnInit } from '@angular/core';
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { filter, Subscription } from 'rxjs';
import { SidebarService } from '../../../services';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule
  ]
})
export class HeaderComponent implements OnInit {
  private subscription!: Subscription;
  private deferredPrompt: any = null;
  public isSidebarOpen = false;
  public currentPage: string = 'home';
  public isHoverSalir: boolean = false;
  public menuItems: any[] = [
    { 
      key: 'home', 
      label: 'Home', 
      icon: 'nav-home', 
      isHover: false 
    },
    {
      key: 'asistencia',
      label: 'Asistencia',
      icon: 'nav-asistencia',
      isHover: false,
      isExpanded: false,
      subItems: [
        {
          key: 'configuracion-asistencia',
          label: 'Configuración',
          route: 'listado-empresas',
          isHover: false
        },
        {
          key: 'seguimiento-asistencia',
          label: 'Seguimiento',
          route: 'listado-ac-ejecucion',
          isHover: false
        },
        {
          key: 'reportes-asistencia',
          label: 'Reportes',
          route: 'listado-ac',
          isHover: false
        }
      ]
    }
  ];
  user: any = null;

  constructor(
    private readonly _router: Router,
    private readonly _sidebarService: SidebarService
  ) {}

  ngOnInit() {
    this.user = null; // Aquí deberías obtener los datos del usuario desde el servicio correspondiente

    this.subscription = this._sidebarService.toggleSidebar$.subscribe(() => {
      this.toggleSidebar();
    });

    this.setCurrentPageFromUrl();
    this._router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.setCurrentPageFromUrl();
      });

    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      this.deferredPrompt = e;
    });
  }

  setCurrentPageFromUrl() {
    const url = this._router.url;

    if (url === '/' || url.startsWith('/home')) {
      this.currentPage = 'home';
    }

    // Sección CONFIGURACIÓN
    else if (
      url.startsWith('/listado-empresas') ||
      url.startsWith('/listado-empresas/configuracion-asistencia')
    ) {
      this.currentPage = 'configuracion-asistencia';
    }

    // Sección SEGUIMIENTO
    else if (
      url.startsWith('/listado-ac-ejecucion') ||
      url.startsWith('/listado-ac-ejecucion/seguimiento-asistencia')
    ) {
      this.currentPage = 'seguimiento-asistencia';
    }

    // Sección REPORTES
    else if (
      url.startsWith('/listado-ac') ||
      url.startsWith('/listado-acdetalle-reporte-asistencia')
    ) {
      this.currentPage = 'reportes-asistencia';
    }

    else {
      this.currentPage = 'home';
    }

    console.log('Ruta actual:', url, 'Página detectada:', this.currentPage);
  }

  toggleSubmenu(item: any) {
    if (item.subItems) {
      item.isExpanded = !item.isExpanded;
    } else {
      this.setPage(item.key);
    }
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  closeSidebar() {
    this.isSidebarOpen = false;
  }

  setPage(page: string) {
    this.currentPage = page;
    this._router.navigate(['/', page]);
    this.closeSidebar();
  }

  @HostListener('document:keydown.escape')
  onEsc() {
    this.closeSidebar();
  }

  get canInstall(): boolean {
    return !!this.deferredPrompt;
  }

  instalarApp() {
    if (this.deferredPrompt) {
      this.deferredPrompt.prompt();
      this.deferredPrompt.userChoice
        .then((choiceResult: any) => {
          if (choiceResult.outcome === 'accepted') {
            // this.toast.showSuccess('App instalada correctamente');
          } else {
            // this.toast.showError('Instalación cancelada');
          }
          this.deferredPrompt = null;
        })
        .catch((error: any) => {
          console.error('Error al mostrar el prompt de instalación:', error);
          // this.toast.showError('Error al intentar instalar la aplicación');
        });
    } else {
      // this.toast.showInfo(
      //   'La aplicación ya está instalada o no es compatible con este navegador',
      // );
    }
  }

  logOut() {
  }
}
